import type { WorldFeature } from '../types';
import { countryFeature } from './countryFeature';

export const COUNTRY_FEATURES: readonly WorldFeature[] = [countryFeature];

export { countryFeature } from './countryFeature';
export type { WindmillKind, WindmillInstance } from './windmills';
export {
  buildWindmillObstacle,
  windmillSailHeight,
  windmillSweepFootprint,
  createWindmillSailAnimator,
  drawSailSpeed,
  SAIL_ROTATION_SPEED_BASE,
} from './windmills';
export type { TreePlacement, IsBlocked, TreeGround } from './trees';
export {
  buildTrunkTemplate,
  buildCrownTemplate,
  drawTreeShape,
  placeOrchardTrees,
  placeGardenTrees,
  placeCloisterTrees,
  placeYardTrees,
  TREE_CROWN_REACH_M,
  TREE_TRUNK_REACH_M,
} from './trees';
export type { FarmSize, FarmData, FarmPlacement } from './farms';
export { buildFarmTemplate, buildFarmObstacle, placeFarmTrees } from './farms';
export type { VegetationCounts, TreeMeshes, CollectedTrees } from './vegetation';
export { collectAllTrees, buildTrees } from './vegetation';
export { crownKeepOut, roadKeepOut, vegetationKeepOut } from './keepOut';
